import React, {useEffect, useRef, useState, useMemo} from "react";
import FlexLayout from "../component/FlexLayout";
import Acm from "../component/Acm";
import i18n from 'i18next';
import "./yuque.css"
import {getAuthStatus} from "../ApiService";
import {Layout, Menu, message, Modal, Tooltip} from "antd";
import ThinkupForIframe from '../component/ThinkupForIframe';
import TU from '@oscloudlab/thinkup'
import {yuqueLogin} from "../util/login";
import SideButtons from "../component/SideButtons";
import {CodeSandboxOutlined, HomeOutlined, YoutubeOutlined} from "@ant-design/icons";
import Icons from "../component/icons/Icons";
import * as postRobot from "post-robot";

const { Content, Sider , Footer} = Layout;
const vgenUrl = process.env.REACT_APP_VGEN_URL+"?source=yuquerunner"
const vgenAdUrl = process.env.REACT_APP_VGEN_URL+"/activityPage?source=yuquerunner"
const items = [
  {
    key: 'cgen',
    icon: <CodeSandboxOutlined />,
    label: 'Cgen 代码沙箱AI助理',
    checked: true
  },
  {
    key: 'vgen',
    icon: <YoutubeOutlined />,
    label: 'Vgen 智慧学伴',
    extra: <div className={'vgen-menu-extra'}>
      <ul>
        <li>· 注册送600饼干</li>
      </ul>
    </div>
  }
];
export default () => {
  const [failed, setFailed] = useState(false);
  const [code, updateCode] = useState([]);
  const [lang, updateLang] = useState(["python"]);
  const [preview, updatePreview] = useState("");
  const [emSent, setEmSent] = useState(false);
  //
  const [showAI, setShowAI] = useState(true);
  const [aiCollapsed, setAiCollapsed] = useState(false);
  const [oldCode, setOldCode] = useState(null);
  const [oldLang, setOldLang] = useState(null);
  const [error, setError] = useState(null);

  const [sourceWindow, setSourceWindow] = useState();
  const sourceWindowRef = useRef(sourceWindow); // 创建一个 ref 来追踪最新的状态

  const acmRef = useRef(null);
  const [autoRun, setAutoRun] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [initDark, setInitDark] = useState(false);
  const [token, setToken] = useState(null);
  const [closeCallback, setCloseCallback] = useState(null);
  const [isDebugging, setIsDebugging] = useState(false);
  const [authInfo, setAuthInfo] = useState(null);
  const [currentNav, setCurrentNav] = useState('cgen');



  const queryParams = new URLSearchParams(window.location.search);
  const reader = queryParams.get('reader'); // 获取 reader 参数
  const theme = queryParams.get('theme'); // 获取 主题 参数
  const localize = queryParams.get('localize'); // 获取 国际化 参数
  const bindSuccessTip = queryParams.get('bindSuccessTip'); // 是否需要绑定手机号成功提示

  useEffect(() => {
    if (bindSuccessTip === 'true') {
      message.success('手机号绑定成功！');
    }
    document.body.classList.add('yuque');
    reader === "1" && setReadOnly(true)
    if (theme === "dark"){
      document.body.classList.add('dark')
      setInitDark(true)
    }
    (localize && localize.startsWith("en")) ? i18n.changeLanguage('en'): i18n.changeLanguage('zh');
    console.log("reader", reader, theme, localize)

    requestYuque("getUserId").then((res) => {
      console.log("getUserId", res)
      let token = queryParams.get('token');
      if (token){
        localStorage.setItem(res.userId, token);
      }else{
        token = localStorage.getItem(res.userId);
      }
      console.log("token", res, token)
      // if (!token){
      //   yuqueLogin();
      //   return false;
      // }
      setToken(token)
      return getAuthStatus(token);
    }).then((res) => {
      setAuthInfo(res.data)
    }).catch((error) => {
      setAuthInfo(error.response.data)
    });
    requestYuque("getCode").then((res) => {
      console.log("getCodeResponse", res)
      res.lng = res.lng || 'javascript'
      res.lng = res.lng === 'shell' ? 'bash' : res.lng
      res.lng = res.lng === 'go' ? 'golang' : res.lng
      res.lng = res.lng === 'sql' ? 'mysql' : res.lng
      res.lng = res.lng === 'vbnet' ? 'vb' : res.lng
      res.lng = res.lng === 'python' ? 'python3' : res.lng
      res.lng = res.lng === 'verilog' ? 'systemverilog' : res.lng
      if(res.lng){
        updateCode([res.code])
        setOldCode([res.code])
        localStorage.setItem("code_"+res.lng, JSON.stringify([res.code]));
      }
      if (res.lng === 'html'){
        updateLang(['html','css','javascript']);
      }else {
        updateLang([res.lng])
      }
      setOldLang(res.lng)
      setEmSent(true)
    })
    requestYuque("resize", {width:"80%",height:"80vh"}).then((res) => {
      console.log("resizeResponse", res)
    });
    //刷新回调
    window.addEventListener('beforeunload', () => {
      console.log("beforeunload")
      // requestYuque("cancel").then((res) => {
      //   console.log("cancelResponse", res)
      // });
    });

  }, []);

  useEffect(() => {
    sourceWindowRef.current = sourceWindow; // 在状态更新时更新 ref
  }, [sourceWindow]);

  //更改语言同步到智能助理
  useEffect(() => {
    TU.setInputs({lang});
  }, [lang]);

  const requestYuque = (action, data) => {
    return new Promise((resolve, reject) => {
      const requestID = action + "-" + Date.now();
      // 发送消息到父窗口
      const requestData = {
        ...(data || {}),
        href: window.location.href,
        requestID,
        name: action,
      }
      console.log("yuqueRequest", requestData)
      window.parent.postMessage(requestData, '*');

      // 创建处理响应的函数
      const handleResponse = (event) => {
        if (event.origin.endsWith(".yuque.com") && event.data.requestID === requestID) {
          // 如果请求ID匹配，则解析Promise
          console.log("yuqueResponse", event.data)
          resolve(event.data);
          // 移除事件监听器
          window.removeEventListener('message', handleResponse);
        }
      };

      // 添加事件监听器
      window.addEventListener('message', handleResponse);

      // 设置一个超时，防止无限等待
      const timeout = setTimeout(() => {
        // 移除事件监听器
        window.removeEventListener('message', handleResponse);
        reject(new Error('Request timed out: ' + requestID));
      }, 5000); // 5秒超时

      // 确保在正确的条件下清除超时
      const originalResolve = resolve;
      resolve = (data) => {
        clearTimeout(timeout); // 当请求成功后清除超时
        originalResolve(data);
      };
    });
  }

  const sendYuqueCode = (code) => {
    requestYuque("updateCode", {code}).then((res) => {
      console.log("updateCodeResponse", res)
    })
  }

  const onLoad = () => {
    setTimeout(() => {
      requestYuque("loaded").then((res) => {
        console.log("loadedResponse", res)
      });
    }, 0)
  }

  const onRunResult = (result) => {
    setFailed(result.failed);
    if (result.failed){
      setError(result.error);
    }
  }

  function closeMe() {
    const close = () => {
      requestYuque("cancel").then((res) => {
        console.log("closeResponse", res)
      });
    }
    console.log(closeCallback, 'closeCallback')
    if (closeCallback) {
      Modal.confirm({
        title: '提示',
        content: '是否保存到文档？',
        okText: '是',
        cancelText: '否',
        onOk: () => {
          closeCallback();
          close();
        },
        onCancel: () => {
          close();
        }
      })
    } else {
      close();
    }
  }
  const fullSize = () => {
    if (currentNav === 'cgen'){
      const targetWin = window.open("/", "blank")
      targetWin.addEventListener('load', () => {
        postRobot.send(targetWin, 'send',{
          aiEnabled:true,
          dark: initDark,
          code: code,
          lang: lang,
        });
      });
    }else if (currentNav === 'vgen'){
      window.open(vgenUrl, "blank")
    }
  }

  const copyCode = (code) => {
    return requestYuque("copyCode", {"code": code})
  }

  const linkToken = useMemo(() => {
    let tokenStr = document.cookie.split(';').find(e => e.split('=')[0].indexOf('token') > -1);
    tokenStr = tokenStr ? tokenStr.split('=')?.[1] : '';

    return token || tokenStr;
  }, [token]);

  const handleDebugStatus = (debugStatus) => {
    //console.log('handleDebugStatus', debugStatus)
    let debugging = debugStatus==="调试中";
    setIsDebugging(debugging)
    setAiCollapsed(debugging)
  };

  useEffect(() => {
    if (currentNav === 'cgen') {
      console.log('cgen');
    } else if (currentNav === 'vgen') {
      console.log('vgen')
    }
  }, [currentNav]);

  const menuClick = e => {
    setCurrentNav(e.key)
  };

  return (
  <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
      <div className={`yuque-header`}>

        {/*<h3 style={{display: "inline"}}>「很抱歉，功能太火爆，服务暂不可用，正在进行扩容升级」</h3>*/}
        {i18n.language === "en" ? (
          <>
            {/*, Yunyan Cloudlab: Let knowledge run. We invite you to experience more features!*/}
            <h3 style={{display: "inline"}}>
              Playground
            </h3> Technical support is provided by
            <a className="linkText" href={process.env.REACT_APP_CLOUD_LAB_URL} target="_blank" rel="noopener noreferrer">
              &nbsp;Yunyan Cloudlab&nbsp;
            </a>
            to complete registration
            {/* <a className="linkText" href={registreUrl} target="_self" rel="noopener noreferrer">
                  registration&nbsp;
                </a> */}
            and activate full service permissions. For problem feedback, please click
            <a className="linkText" href="https://cloudlab.yuque.com/org-wiki-cloudlab-smmg5w/txzm5f/lwyygrcf2gc8v01w?singleDoc#" target="_blank" rel="noopener noreferrer">
              &nbsp;here&nbsp;
            </a>
            for problem feedback
          </>
        ) : (
          <>
            {/*, 云燕实验室, 让知识run起来, 更多功能欢迎体验*/}
            <h3 className="title-run">
              <HomeOutlined style={{margin:"0 10px"}}/><b>云燕工具广场</b>
            </h3>
            语雀声明：本服务由独立第三方
            <a className="linkText" href="https://www.cloudlab.top" target="_blank"
               rel="noopener noreferrer">&nbsp;云燕实验室&nbsp;</a>
            支持, 请安全合规的使用！
            {/*<a className="linkText"*/}
            {/*   href="https://vgen.cloudlab.top/?source=yuquerunner"*/}
            {/*   target="_blank" rel="noopener noreferrer">*/}
            {/*  &nbsp;Vgen 智慧学伴限时福利：注册送200饼干(可解析120分钟视频)+抽京东卡/B站大会员+邀好友赢京东卡！[立即领取]&nbsp;*/}
            {/*</a>*/}
            {/*。*/}
            &nbsp;&nbsp;&nbsp;&nbsp;
            {/*<a className="linkText"*/}
            {/*   href="https://cloudlab.yuque.com/org-wiki-cloudlab-smmg5w/cgvrmv/bhwqd748z7ynp8mp?singleDoc#"*/}
            {/*   target="_blank" rel="noopener noreferrer">*/}
            {/*  &nbsp;「520代码有光」创作交互式技术博客赢取奖励>>立即参与&nbsp;*/}
            {/*</a>*/}
          </>
        )}
        <div
          className={'fullSize'}
          onClick={fullSize}

        >
        <Icons.FullSize size={20}/>
        </div>
        <div
          className={'close'}
          onClick={closeMe}
        >
        </div>
    </div>
    <Layout hasSider style={{ flex: 1}}>
      <Sider className="yuque-sider"
             width={180}
      >
        <Menu
          onClick={menuClick}
          style={{ width: 180 }}
          defaultSelectedKeys={['cgen']}
          mode="inline"
          items={items}
        />
        {/*vgen活动引流*/}
        {/*<a className="yuque-sider-ad" href={vgenAdUrl} target="_blank" rel="noopener noreferrer">*/}
        {/*  <img src="/assets/vgen-banner-left.jpg" alt="广告" />*/}
        {/*</a>*/}
      </Sider>
      <Layout>
        <Content>

          <div style={{ height: '100%',display: currentNav==='cgen' ? 'flex' : 'none', flexDirection: "column"}}>
            <div className={`yuque-page`}>


              <div className={`yuque-body`}>
                {emSent && authInfo &&(
                  <FlexLayout ratio={(showAI && !aiCollapsed)?"66.7%":"100%"}>
                    <Acm
                      key={1}
                      lang={lang}
                      code={code}
                      updateCode={updateCode}
                      updateLang={updateLang}
                      preview={preview}
                      updatePreview={updatePreview}
                      embedded={true}
                      sourceWindow={sourceWindow}
                      aiEnabled={false}
                      oldCode={oldCode}
                      setOldCode={setOldCode}
                      oldLang={oldLang}
                      ref={acmRef}
                      autoRun={autoRun}
                      readOnly={readOnly}
                      initDark={initDark}
                      onRunResult={onRunResult}
                      sendYuqueCode={sendYuqueCode}
                      onLoad={onLoad}
                      platform='yuque'
                      setCloseCallback={setCloseCallback}
                      handleDebugStatus={handleDebugStatus}
                      setAiCollapsed={setAiCollapsed}
                      authInfo={authInfo}
                    />

                    {/* 智能助理iframe */}

                    <ThinkupForIframe
                      linkToken={linkToken}
                      customCopy={copyCode}
                      handleCollapse={()=>{setAiCollapsed(true)}}
                    />
                  </FlexLayout>
                )}
              </div>
              <SideButtons showAI={showAI} aiCollapsed={aiCollapsed} setAiCollapsed={setAiCollapsed} authInfo={authInfo} yuque={true}/>
            </div>
            {/*<Footer className="yuque-footer"*/}
            {/*        onClick={()=> window.open(vgenUrl, "blank")}*/}
            {/*>*/}
            {/*  <div className="yuque-footer-banner">*/}
            {/*    <img src="/assets/Cgen-banner.png?v=20260519" alt="小助理微信"/>*/}
            {/*  </div>*/}
            {/*</Footer>*/}
          </div>
          <div style={{ height: '100%',display: currentNav==='vgen' ? 'block' : 'none' }}>
            <iframe src={vgenUrl}
                    style={{ width: '100%', height: '100%', border: 0, borderRadius: 4, overflow: 'hidden' }}
                    title="Cgen AI Assistant"
                    allow="accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment;"/>
          </div>
        </Content>

      </Layout>
    </Layout>
  </div>
  );


}
